import {defineMessages} from 'react-intl'

export default defineMessages({
    close: {
        id: 'components.AiVoiceSuggestDrawer.close',
        defaultMessage: 'Close',
    },
    loaded: {
        id: 'components.AiVoiceSuggestDrawer.loaded',
        defaultMessage: 'Auto-suggest',
    },
    processing: {
        id: 'components.AiVoiceSuggestDrawer.processing',
        defaultMessage: 'Beaming Skynet..',
    },
    callToAction: {
        id: 'components.AiVoiceSuggestDrawer.callToAction',
        defaultMessage: 'Find the right voice talent, using our AI',
    },
    feedback: {
        id: 'components.AiVoiceSuggestDrawer.feedback',
        defaultMessage: "<b>We'd love your feedback!</b> Share your experience or any question with us on ",
    },
    usageInstructions: {
        id: 'components.AiVoiceSuggestDrawer.usageInstructions',
        defaultMessage: `<item>Paste a bit of your script below</item>
            <item>Our AI will process your input in 3-5 sec.</item>
            <item>Get suggestions for the best voice talents and filters based on your input</item>`,
    },
    bestExperiencesPrompt:{
        id:'components.AiVoiceSuggestDrawer.bestExperiencesPrompt',
        defaultMessage: "Provide 20 words, or more, to get the best suggestion, based on your script.."
    },
    betaEmail: {
        id:'components.AiVoiceSuggestDrawer.betaEmail',
        defaultMessage: 'beta@voicearchive.com'
    }
})
